import { render, staticRenderFns } from "./PageBalanceRecord.vue?vue&type=template&id=6e6e96d0"
import script from "./PageBalanceRecord.vue?vue&type=script&lang=js"
export * from "./PageBalanceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports